import { Link } from 'react-router-dom';

const PLANS = [
  {
    title: 'Site Vitrine',
    icon: 'ri-layout-line',
    gradient: 'from-teal-500 to-emerald-500',
    price: 69,
    popular: false,
    badge: null,
    description: 'Présentez votre activité et captez des clients locaux',
    features: [
      { text: 'Design sur mesure unique', icon: 'ri-palette-line' },
      { text: 'Responsive mobile parfait', icon: 'ri-smartphone-line' },
      { text: 'Formulaire de contact / devis', icon: 'ri-mail-send-line' },
      { text: 'Réservation en ligne intégrée', icon: 'ri-calendar-check-line' },
      { text: 'Optimisation SEO Google', icon: 'ri-search-line' },
      { text: 'Hébergement & maintenance inclus', icon: 'ri-shield-check-line' },
      { text: 'Livraison en 7 jours max', icon: 'ri-rocket-line' },
    ],
  },
  {
    title: 'Site E-commerce',
    icon: 'ri-store-2-line',
    gradient: 'from-emerald-500 to-teal-500',
    price: 149,
    popular: true,
    badge: '⭐ PLUS POPULAIRE',
    description: 'Vendez en ligne avec une boutique complète et optimisée',
    features: [
      { text: 'Boutique en ligne complète', icon: 'ri-shopping-bag-line' },
      { text: 'Design sur mesure unique', icon: 'ri-palette-line' },
      { text: 'Paiement en ligne sécurisé', icon: 'ri-secure-payment-line' },
      { text: 'Gestion commandes & stocks', icon: 'ri-box-3-line' },
      { text: 'SEO avancé & fiches produits', icon: 'ri-search-line' },
      { text: 'Hébergement & maintenance inclus', icon: 'ri-shield-check-line' },
      { text: 'Livraison en 7 jours max', icon: 'ri-rocket-line' },
      { text: 'Analytics & suivi des ventes', icon: 'ri-line-chart-line' },
    ],
  },
];

export default function PricingSection() {
  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-xs font-bold text-emerald-500 uppercase tracking-[4px] mb-3">Tarifs transparents</p>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-slate-900 mb-4">
            Prix Simples,{' '}
            <span className="bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">Zéro Surprise</span>
          </h2>
          <p className="text-sm sm:text-lg text-slate-500 max-w-2xl mx-auto">
            À partir de <strong className="text-slate-700">69€/mois sans engagement</strong> · Livraison garantie en 7 jours · Paiement en plusieurs fois possible
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 max-w-3xl mx-auto">
          {PLANS.map((plan) => (
            <div
              key={plan.title}
              className={`relative bg-white rounded-3xl flex flex-col overflow-hidden transition-all duration-300 hover:-translate-y-2 ${
                plan.popular
                  ? 'border-2 border-emerald-400 shadow-2xl shadow-emerald-500/15'
                  : 'border-2 border-slate-100 shadow-lg'
              }`}
            >
              {/* Bandeau */}
              {plan.badge && (
                <div className={`w-full py-2.5 text-center text-xs font-black text-white bg-gradient-to-r ${plan.gradient} tracking-widest uppercase`}>
                  {plan.badge}
                </div>
              )}

              <div className="p-7 sm:p-9 flex flex-col flex-1">
                {/* Header */}
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${plan.gradient} flex items-center justify-center mb-5 flex-shrink-0`}>
                  <i className={`${plan.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-black text-slate-900 mb-1">{plan.title}</h3>
                <p className="text-sm text-slate-400 mb-5">{plan.description}</p>

                {/* Prix */}
                <div className="flex items-baseline gap-1 mb-1">
                  <span className="text-xs font-semibold text-slate-400">à partir de</span>
                </div>
                <div className="flex items-end gap-2 mb-6">
                  <span className={`text-5xl sm:text-6xl font-black bg-gradient-to-r ${plan.gradient} bg-clip-text text-transparent`}>
                    {plan.price}€
                  </span>
                  <div className="mb-2">
                    <span className="text-sm text-slate-400 block">/mois</span>
                    <span className="text-xs font-bold text-emerald-500 whitespace-nowrap">sans engagement</span>
                  </div>
                </div>

                {/* Séparateur */}
                <div className="border-t border-slate-100 mb-5"></div>

                {/* Features */}
                <div className="space-y-3 mb-7 flex-1">
                  {plan.features.map((f, i) => (
                    <div key={i} className="flex items-center gap-3">
                      <div className={`w-7 h-7 flex items-center justify-center rounded-lg bg-gradient-to-br ${plan.gradient} flex-shrink-0`}>
                        <i className={`${f.icon} text-xs text-white`}></i>
                      </div>
                      <span className="text-sm text-slate-700 font-medium">{f.text}</span>
                    </div>
                  ))}
                </div>

                <Link
                  to="/offres"
                  className={`w-full flex items-center justify-center gap-2 py-4 rounded-xl text-sm font-bold transition-all duration-300 hover:scale-[1.02] whitespace-nowrap cursor-pointer ${
                    plan.popular
                      ? `bg-gradient-to-r ${plan.gradient} text-white shadow-lg shadow-emerald-500/25 hover:shadow-xl hover:shadow-emerald-500/35`
                      : 'bg-slate-50 text-slate-700 border-2 border-slate-200 hover:border-emerald-300 hover:text-emerald-700 hover:bg-emerald-50'
                  }`}
                >
                  <span>Voir les détails</span>
                  <i className="ri-arrow-right-line text-base"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Mentions */}
        <div className="text-center mt-8 sm:mt-10 space-y-2">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-slate-500 font-medium">
            <span className="flex items-center gap-1.5"><i className="ri-check-double-line text-emerald-500"></i>Sans engagement</span>
            <span className="flex items-center gap-1.5"><i className="ri-check-double-line text-emerald-500"></i>Paiement en plusieurs fois</span>
            <span className="flex items-center gap-1.5"><i className="ri-check-double-line text-emerald-500"></i>Réductions 6 ou 12 mois</span>
          </div>
          <p className="text-xs text-slate-400">Chaque site comprend l'hébergement, la maintenance, le SSL et le support inclus</p>
        </div>
      </div>
    </section>
  );
}
